app.directive('programEditorWeekDayTabPane', function ($log) {
    return {
        restrict: 'A',
        scope: {
            model: '=programEditorWeekDayTabPane',
            weekIndex: '=weekIndex',
            dayIndex: '=dayIndex'
        },
        transclude: true,
        terminal: true,
        link: function ($scope, $element, $attrs, $ctrls, $transclude) {
            $transclude($scope.$new(true), function (clone, childScope) {
                $element.append(clone);

                childScope.programEditorWeekDayTabPane = {};

                $scope.$watch('model', function (newValue) {
                    if (!angular.isObject(newValue)) {
                        // noinspection JSValidateTypes
                        newValue = {'listItems': []};
                    }

                    if (!angular.isArray(newValue.listItems)) {
                        newValue.listItems = [];
                    }

                    childScope.programEditorWeekDayTabPane.model = newValue;
                });

                $scope.$watch('weekIndex', function (newValue) {
                    childScope.programEditorWeekDayTabPane.weekIndex = newValue;
                });

                $scope.$watch('dayIndex', function (newValue) {
                    childScope.programEditorWeekDayTabPane.dayIndex = newValue;
                });

                childScope.programEditorWeekDayTabPane.onDrop = function ($event, model) {
                    // Exercise is dropped
                    if (model.draggable.is('[data-exercise-info]')) {
                        var exerciseInfo = JSON.parse(model.draggable.attr('data-exercise-info'));
                        childScope.programEditorWeekDayTabPane.addNewListItem(null, exerciseInfo);
                    }
                };

                childScope.programEditorWeekDayTabPane.addNewListItem = function ($event, exerciseInfo) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    var baseModel = {'mode': 'one_exercise', 'exercises': [], 'text': null, 'timeMin': null, 'timeSec': null};

                    if (exerciseInfo) {
                        baseModel.exercises.push(exerciseInfo);
                    }

                    childScope.programEditorWeekDayTabPane.model.listItems.push(baseModel);
                };

                childScope.$on('programEditorExerciseListTile.requestMove', function ($event, oldIndex, moveToIndex) {
                    if (oldIndex === moveToIndex) {
                        return;
                    }

                    var currentListItems = childScope.programEditorWeekDayTabPane.model.listItems;
                    var reorderedListItems = [];

                    for (var i = 0; i < currentListItems.length; i++) {
                        if (i === oldIndex) {
                            // This is the old item to move, just skip it.
                            continue;
                        }

                        if (i === moveToIndex && oldIndex > moveToIndex) {
                            reorderedListItems.push(currentListItems[oldIndex]);
                        }

                        reorderedListItems.push(currentListItems[i]);

                        if (i === moveToIndex && oldIndex < moveToIndex) {
                            reorderedListItems.push(currentListItems[oldIndex]);
                        }
                    }

                    childScope.programEditorWeekDayTabPane.model.listItems = reorderedListItems;
                });

                childScope.$on('programEditorExerciseListTile.requestDelete', function ($event, indexToDelete) {
                    var currentListItems = childScope.programEditorWeekDayTabPane.model.listItems;
                    var filteredListItems = [];

                    for (var i = 0; i < currentListItems.length; i++) {
                        if (i === indexToDelete) {
                            // This is the item to delete, so skip it.
                            continue;
                        }

                        filteredListItems.push(currentListItems[i]);
                    }

                    childScope.programEditorWeekDayTabPane.model.listItems = filteredListItems;
                });
            });
        }
    };
});
